import path from 'path-browserify';
import { useLocation, useMatches } from 'react-router-dom';

import DebugConsole from '@helper/functions/console';

import CrumbLink from './CrumbLink';

export default function Breadcrumb() {
  const matches = useMatches();

  const location = useLocation();

  const crumbs = matches
    .filter((match: RouterHandleMatch) => Boolean(match.handle?.crumb))
    .map((match: RouterHandleMatch) => match.handle.crumb({ pathname: location.pathname }));

  const urls = [];

  let hasBrokenLink = false;

  crumbs.reduce((acc, crumb, idx) => {
    if (hasBrokenLink) {
      urls.push('');
      return acc;
    }
    if (!crumb.to) {
      if (idx < crumbs.length - 1) {
        DebugConsole.warn(
          'Broken breadcrumb link detected! Check the react router to make sure that all parent routes return a `to` property from the `crumb` function.',
        );
      }

      hasBrokenLink = true;
      urls.push('');
      return acc;
    }

    acc.push(crumb.to);
    const crumbPath = path.join(...acc);
    const url = new URL(crumbPath, window.location.origin);
    urls.push(url.pathname);
    return acc;
  }, []);

  return (
    <nav aria-label="Breadcrumbs" className="nsw-breadcrumb">
      <ol className="nsw-breadcrumb__list">
        {crumbs.map((item, idx) =>
          crumbs.length < 2 ? null : (
            <li className="nsw-breadcrumb__item" key={item.name}>
              <CrumbLink to={idx === crumbs.length - 1 ? '' : urls[idx]}>{item.name}</CrumbLink>
            </li>
          ),
        )}
      </ol>
    </nav>
  );
}
